import { useCallback } from 'react';
import { TrackingProp } from './types';

interface UseTrackWidgetArgs {
  tracking?: TrackingProp;
  widgetState: Widget<any>;
  currentPage?: PageVersion;
  site?: Site;
}

export interface TrackWidgetExtra {
  [key: string]: any;
}

/**
 * Hook to standardize widget tracking calls across the app.
 * Adds shared metadata and handles safe no-op when tracking is unavailable.
 */
export function useTrackWidget({
  tracking,
  widgetState,
  currentPage,
  site,
}: UseTrackWidgetArgs) {
  return useCallback(
    (action: string, extra: TrackWidgetExtra = {}) => {
      if (!tracking?.trackEvent) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('Tracking is not configured for useTrackWidget');
        }
        return;
      }

      const config: any = widgetState?.config || {};
      const baseLabel =
        config.analyticsLabel ||
        config.buttonAnalyticsText ||
        config.analyticsLinkText ||
        config.displayText ||
        config.label ||
        config.url ||
        widgetState.id;

      tracking.trackEvent({
        action,
        widgetType: widgetState.type,
        widgetId: widgetState.id,
        widgetLabel: baseLabel,
        siteDomain: site?.domain,
        pageSlug: currentPage?.slug,
        pageId: currentPage?.id,
        timestamp: new Date().toISOString(),
        ...extra,
      });
    },
    [tracking, widgetState, currentPage, site]
  );
}
